import React, { useState } from "react";
// import { useHistory } from "react-router-dom";

import { getCookie, setCookie } from "../../utility/Cookie";

const SettingsInfoEdit = () => {
  const [user] = useState(JSON.parse(getCookie("_g_")));

  const [isPending, setIsPending] = useState({
    UPassword: false,
    UData: false,
  });
  const [isMsg, setIsMsg] = useState({
    UPassword: "",
    UData: "",
    EUPassword: {},
    SUPassword: "",
  });

  const [userData, setUserData] = useState({
    first_name: user?.first_name || "",
    last_name: user?.last_name || "",
    email: user?.email || "",
  });

  const [password, setPassword] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const handleChangeEditUser = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeUserPassword = (e) => {
    setPassword({
      ...password,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitEditUser = (e) => {
    e.preventDefault();
    setIsPending({
      ...isPending,
      UData: true,
    });
    if (
      userData.first_name === "" ||
      userData.last_name === "" ||
      userData.email === ""
    ) {
      setIsMsg({
        ...isMsg,
        UData: "Please fill all the fields",
      });
      setIsPending({
        ...isPending,
        UData: false,
      });
    } else {
      fetch(`${process.env.REACT_APP_BASE_URL}/myprofile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(userData),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setIsPending({
              ...isPending,
              UData: false,
            });
            setCookie(
              "_g_",
              JSON.stringify({
                first_name: data.msg.first_name,
                last_name: data.msg.last_name,
                email: data.msg.email,
              }),
              1
            );
            localStorage.setItem(
              "_g_user",
              JSON.stringify({
                first_name: data.msg.first_name,
                last_name: data.msg.last_name,
                email: data.msg.email,
              })
            );
            window.location.reload();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const validation = {
    current_password: (val) => val !== "" && val.length >= 8,
    new_password: (val) =>
      val &&
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#/|])[A-Za-z\d@$!%*?&#/|]{8,}$/.test(
        val
      ),
    confirm_password: (val) => val === password.new_password,
  };

  const validateFrom = () => {
    let errors = {};
    let valid = false;
    for (let key of Object.keys(password)) {
      if (validation[key] !== "") {
        errors[key] = !validation[key](password[key]);
        valid |= errors[key];
      }
    }
    return {
      errors: errors,
      valid: !valid,
    };
  };

  const handleSubmitUserPassword = (e) => {
    e.preventDefault();
    const { valid, errors } = validateFrom();
    setIsMsg({
      ...isMsg,
      EUPassword: errors,
    });
    const data = {
      current_password: password.current_password,
      new_password: password.new_password,
    };
    setIsPending({
      ...isPending,
      UPassword: true,
    });
    if (!valid) {
      setIsPending({
        ...isPending,
        UPassword: false,
      });
    } else {
      fetch(`${process.env.REACT_APP_BASE_URL}/reset-password`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setIsPending({
              ...isPending,
              UPassword: false,
            });
            setIsMsg({
              ...isMsg,
              EUPassword: {},
              SUPassword: "success password changed",
            });
          }
          if (data.status === "error") {
            setIsPending({
              ...isPending,
              UPassword: false,
            });
            setIsMsg({
              ...isMsg,
              EUPassword: {},
              SUPassword: data.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // console.log(data)
  return (
    <div className="settings-page">
      <div className="container">
        <div className="row">
          <div className="col-md-7 m-auto">
            <div className="personal-information">
              <h6>Personal Information</h6>
              <div className="personal-information-item">
                <form className="form-content" onSubmit={handleSubmitEditUser}>
                  <div className="row">
                    <div className="col-md-6">
                      <label>First Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                        value={userData.first_name}
                        name="first_name"
                        onChange={handleChangeEditUser}
                      />
                    </div>
                    <div className="col-md-6">
                      <label>Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Last Name"
                        value={userData.last_name}
                        name="last_name"
                        onChange={handleChangeEditUser}
                      />
                    </div>
                  </div>
                  <div className="from-group mt-3">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={userData.email}
                      name="email"
                      onChange={handleChangeEditUser}
                    />
                  </div>
                  {
                    <div className="error-msg error">
                      <span>{isMsg.UData}</span>
                    </div>
                  }

                  <div className="from-button">
                    <button className="contButSmall" type="submit">
                      {isPending.UData ? (
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="change-password">
              <h6>Password</h6>
              <div className="change-password-item">
                <form
                  className="form-change-password"
                  onSubmit={handleSubmitUserPassword}
                >
                  <div className="form-group mt-3">
                    <label>Current Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Current Password"
                      name="current_password"
                      onChange={handleChangeUserPassword}
                    />
                  </div>
                  {isMsg.EUPassword?.current_password && (
                    <div className="error-msg error">
                      <span>
                        password must be at least 8 characters long and must
                      </span>
                    </div>
                  )}
                  <div className="form-group mt-3">
                    <label>New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="New Password"
                      name="new_password"
                      onChange={handleChangeUserPassword}
                    />
                  </div>
                  {isMsg.EUPassword?.new_password && (
                    <div className="error-msg error">
                      <span>
                        Password must be at least 8 characters long and contain
                        at least one number, one uppercase and one lowercase
                        letter and one special character
                      </span>
                    </div>
                  )}
                  <div className="form-group mt-3">
                    <label>Confirm New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm New Password"
                      name="confirm_password"
                      onChange={handleChangeUserPassword}
                    />
                  </div>
                  {isMsg.EUPassword?.confirm_password && (
                    <div className="error-msg error">
                      <span>Password does not match</span>
                    </div>
                  )}
                  {isMsg.UPassword && (
                    <div className="error-msg error">
                      <span>{isMsg.UPassword}</span>
                    </div>
                  )}
                  {isMsg.SUPassword && (
                    <div className="success-msg success">
                      <span>{isMsg.SUPassword}</span>
                    </div>
                  )}
                  <div className="from-button">
                    <button className="contButSmall" type="submit">
                      {isPending.UPassword ? (
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Change Password"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsInfoEdit;
